export const SET_PARTICIPANT_SAVING_ACCOUNTS =
  "SET_PARTICIPANT_SAVING_ACCOUNTS";
export const ASSOCIATE_SAVING_ACCOUNT = "ASSOCIATE_SAVING_ACCOUNT";
export const DISSOCIATE_SAVING_ACCOUNT = "DISSOCIATE_SAVING_ACCOUNT";
export const SET_RETIREMENT_INCOME_DATA = "SET_RETIREMENT_INCOME_DATA";
export const RESET_RETIREMENT_INCOME_DATA = "RESET_RETIREMENT_INCOME_DATA";
export const CREATE_RETIREMENT_INCOME = "CREATE_RETIREMENT_INCOME";
export const UPDATE_RETIREMENT_INCOME = "UPDATE_RETIREMENT_INCOME";
export const DELETE_RETIREMENT_INCOME = "DELETE_RETIREMENT_INCOME";
export const ENABLE_RETIREMENT_INCOME = "ENABLE_RETIREMENT_INCOME";
export const DISABLE_RETIREMENT_INCOME = "DISABLE_RETIREMENT_INCOME";
export const SET_IDEAL_RETIREMENT_INCOME = "SET_IDEAL_RETIREMENT_INCOME";
export const RESTORE_SOCIAL_SECURITY_INCOME = "RESTORE_SOCIAL_SECURITY_INCOME";
export const UPDATE_SOCIAL_SECURITY_INCOME = "UPDATE_SOCIAL_SECURITY_INCOME";
export const SET_LIFE_TIME_INCOME = "SET_LIFE_TIME_INCOME";
export const SET_PARTICIPANTS_EVENTS = "SET_PARTICIPANTS_EVENTS";
export const SET_EVENT_DETAILS = "SET_EVENT_DETAILS";
export const SET_UPCOMING_EVENTS = "SET_UPCOMING_EVENTS";
export const SET_WORKING_HOURS = "SET_WORKING_HOURS";
export const SET_AVAILABLE_HOURS = "SET_AVAILABLE_HOURS";
export const SET_UTC_DETAILS = "SET_UTC_DETAILS";
export const SET_FAQ = "SET_FAQ";
export const SET_EVENT_AS_CONFIRMED = "SET_EVENT_AS_CONFIRMED";
export const SET_EVENT_AS_CANCEL = "SET_EVENT_AS_CANCEL";
export const SET_LOADING_PARTICIPANT_EVENTS = "SET_LOADING_PARTICIPANT_EVENTS";
export const SET_EDUCATOR_EVENTS = "SET_EDUCATOR_EVENTS";
export const ADD_EVENT_TO_CURRENT_CALENDAR = "ADD_EVENT_TO_CURRENT_CALENDAR";
export const SET_CLEAN_EVENTS = "SET_CLEAN_EVENTS";
export const TOGGLE_EVENT_MODAL = "TOGGLE_EVENT_MODAL";
export const FETCHING_EVENT_DETAIL = "FETCHING_EVENT_DETAIL";
export const TOGGLE_ONE_ON_ONE_MODAL = "TOGGLE_ONE_ON_ONE_MODAL";
